/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentDeliveryPlans } from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import { getEntities as getRegimen } from 'app/entities/regimen/regimen.reducer';
import { getEntities as getSequences } from 'app/entities/sequence/sequence.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-regimen.reducer';

export const TreatmentRegimenUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentDeliveryPlans = useAppSelector(state => state.treatmentDeliveryPlan.entities);
  const regimen = useAppSelector(state => state.regimen.entities);
  const sequences = useAppSelector(state => state.sequence.entities);
  const treatmentRegimenEntity = useAppSelector(state => state.treatmentRegimen.entity);
  const loading = useAppSelector(state => state.treatmentRegimen.loading);
  const updating = useAppSelector(state => state.treatmentRegimen.updating);
  const updateSuccess = useAppSelector(state => state.treatmentRegimen.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-regimen${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentDeliveryPlans({}));
    dispatch(getRegimen({}));
    dispatch(getSequences({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentRegimenEntity,
      ...values,
      plan: treatmentDeliveryPlans.find(it => it.id.toString() === values.plan?.toString()),
      regimen: regimen.find(it => it.id.toString() === values.regimen?.toString()),
      sequence: sequences.find(it => it.id.toString() === values.sequence?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentRegimenEntity,
          plan: treatmentRegimenEntity?.plan?.id,
          regimen: treatmentRegimenEntity?.regimen?.id,
          sequence: treatmentRegimenEntity?.sequence?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentRegimen.home.createOrEditLabel" data-cy="TreatmentRegimenCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentRegimen.home.createOrEditLabel">Create or edit a TreatmentRegimen</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-regimen-id"
                  label={translate('tinyMedicRestApp.treatmentRegimen.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.startDate')}
                id="treatment-regimen-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.endDate')}
                id="treatment-regimen-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.status')}
                id="treatment-regimen-status"
                name="status"
                data-cy="status"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.active')}
                id="treatment-regimen-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.cursor')}
                id="treatment-regimen-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.lastUpdated')}
                id="treatment-regimen-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.microSec')}
                id="treatment-regimen-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimen.timestampEntry')}
                id="treatment-regimen-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-regimen-plan"
                name="plan"
                data-cy="plan"
                label={translate('tinyMedicRestApp.treatmentRegimen.plan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentDeliveryPlans
                  ? treatmentDeliveryPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.treatmentRegimen.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {regimen
                  ? regimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-sequence"
                name="sequence"
                data-cy="sequence"
                label={translate('tinyMedicRestApp.treatmentRegimen.sequence')}
                type="select"
              >
                <option value="" key="0" />
                {sequences
                  ? sequences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-regimen" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentRegimenUpdate;
